import React from 'react';
import { connect } from 'react-redux';
import { setIsOtherAddress, setSelectedAddress, setIsSubmit, setIsValid } from './userAddressSlice';
import AddressFrm from '../../../Shared/AddressFrm/AddressFrm';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import arrowLeftIcon from './images/arrow-left-icon.svg';

const UserAddress = (props) => {
  let title = '';
  let otherAddressTitle = '';
  let otherAddressSubTitle = '';

  let btnAddressText = '';
  if (props.isDisplaySimActivation || props.isEsimOnly != null && props.isEsimOnly) {
    btnAddressText = 'המשך';
  } else {
    btnAddressText = props._saleType == 'cellular' ? 'המשך לתיאום שליח' : 'לבחירת אופן התקנה';
  }

  switch (props._saleType) {
    case 'tv':
      title = 'הנה החשבונות והכתובות שאפשר לבחור מהם:';
      otherAddressTitle = 'אני רוצה לכתובת אחרת';
      otherAddressSubTitle = `החשבונית של ${window.Config.brand_Name_HE} TV תשלח בנפרד`;
      break;
    case 'cellular':
      title = 'הנה החשבונות שאפשר לבחור מהם:';
      otherAddressTitle = 'אני רוצה לפתוח חשבון';
      otherAddressSubTitle = 'נפרד לשירות הזה';
      break;
    case 'internet':
      title = 'הנה החשבונות והכתובות שאפשר לבחור מהם:';
      break;
  }

  return (
    <div className='user-address'>
      <div className='user-address-wrapper'>
        <div className='user-address-title'> {title} </div>

        <div className='user-address-list'>
          {props.userAddresses.map((data, index) => {
            const address = data.cityName != null ? data.streetName + ' ' + data.home + ',' + data.cityName : '';
            const className = `user-address-item ${data.isDisabled ? 'disabled' : ''}`;
            return (
              <a
                className={className}
                href='javascript:void(0)'
                onClick={() => {
                  handleSelectAddress(data);
                }}
                key={index}>
                <div className='user-address-item-wrapper' style={{backgroundImage:arrowLeftIcon.bg()}}>
                  {address != '' && (
                    <div className='address-item-title'>
                      <div className='title'> חשבון שבכתובת: </div>
                      <div className='title-bold'> {address} </div>
                    </div>
                  )}
                  <div className='details-wrapper'>
                    <div> השירותים שבחשבון: </div>
                    <div className='bold-text'>{data.additionalInfo.productDescription.description} </div>
                    <div className='details'>החבילה שהזמנתם תתווסף לחשבונית שנשלחת ל - {data.additionalInfo.billingAddress}</div>
                  </div>
                </div>
              </a>
            );
          })}
          {(props._saleType == 'tv' || props._saleType == 'cellular') && (
            <div className={props.isOtherAddress ? 'other-address-item open' : 'other-address-item'}>
              <a
                className='other-address-item-wrapper'
                href='javascript:void(0)'
                onClick={() => {
                  handleSelectOtherAddress();
                }}>
                <div className='address-item-title'>
                  <div className='title'> {otherAddressTitle} </div>
                  <div className='title-small'> {otherAddressSubTitle} </div>
                </div>
              </a>
              <div className='details-wrapper'>
                <div>
                  <AddressFrm
                    onError={handleOnError}
                    onValid={handleAddressValidate}
                    onSubmit={props.isSubmit}
                    title={props.isDisplaySimActivation ? 'כתובת מגורים' : null}
                  />
                </div>
                <div className='btn-wrapper'>
                  <BtnSubmit text={btnAddressText} onclick={handleSelectOtherAddressClick} />
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );

  function handleSelectOtherAddressClick() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handleAddressValidate(valid) {
    if (valid) {
      props.setIsSubmit({ isSubmit: false });
      handleSelectOtherAddressAfterValid();
    }
    props.setIsSubmit({ isSubmit: false });
  }

  function handleSelectOtherAddress() {
    let isOtherAddress = props.isOtherAddress;
    props.setIsOtherAddress({ isOtherAddress: !isOtherAddress });
  }

  function handleSelectOtherAddressAfterValid() {
    const userAddress = {
      isOtherAddress: true,
      userDetails: {},
      address: {
        city: props._address.city,
        cityName: props._address.cityName,
        street: props._address.street,
        streetName: props._address.streetName,
        home: props._address.home,
        apartment: props._address.apartment,
        enter: props._address.enter,
        zipCode: props._address.zipCode,
        technicianHours: props._address.technicianHours,
        infrastructure: {},
      },
    };
    props.onSelectUserAddress(userAddress);
  }

  function handleSelectAddress(data) {
    if (data.isDisabled) {
      return;
    }

    props.setIsOtherAddress({ isOtherAddress: false });
    const ban = data.additionalInfo.banId;
    const email = data.additionalInfo.billingAddressIsEmail ? data.additionalInfo.billingAddress : '';
    const identity = data.additionalInfo.identity;
    const accountType = data.additionalInfo.accountType;
    const accountMidType = data.additionalInfo.accountMidType;
    const accountSubType = data.additionalInfo.accountSubType;
    const paymentToken = data.additionalInfo.paymentToken;

    const userAddress = {
      isOtherAddress: false,
      userDetails: {
        ban: ban,
        email: email,
        identity: identity,
        accountType: accountType,
        accountMidType: accountMidType,
        accountSubType: accountSubType,
        paymentToken: paymentToken,
      },
      address: {
        city: data.cityCode,
        cityName: data.cityName,
        street: data.streetCode,
        streetName: data.streetName,
        home: data.home,
        apartment: '',
        enter: '',
        zipCode: data.zipCode,
        technicianHours: null,
        infrastructure: {},
      },
    };
    props.onSelectUserAddress(userAddress);
  }

  function handleOnError(errorId) {
    return;
  }

};

const mapStateToProps = (state) => {
  return {
    isOtherAddress: state.userAddress.isOtherAddress,
    isSubmit: state.userAddress.isSubmit,
    isValid: state.userAddress.isValid,

    //other states
    _address: state.addressForm.form,
    _saleType: state.saleBlock.saleType,
  };
};

const mapDispatchToProps = {
  setIsOtherAddress,
  setSelectedAddress,
  setIsSubmit,
  setIsValid,

  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAddress);
